import { useEffect } from "react";
import { claimStausIcon, IntimateclaimsIcon } from "../../../Assets";

const ClaimFeaturesTabs = ({
  featuresType,
  tabapiData,
  setActiveViewType,
  activeViewType,
}) => {
  const handleFeatureTab = (activeTab) => {
    setActiveViewType(activeTab);
  };

  useEffect(() => {
    if ((featuresType === "GMC") && tabapiData?.find(
              (dumData) => dumData.policy_type_name === featuresType
            )?.intimate_claim_visibility !== 0) {
      setActiveViewType(1);
    } else {
      setActiveViewType(0);
    }
    
  }, [featuresType]);

  return (
    <div className="claim-corner-tabs-cover">
      <div className="claims-corner-feature-tab-cover-wrapper">
        {["GMC", "Top Up Policy", "Parent Policy"].includes(featuresType) ? (
          <>
            {tabapiData?.find(
              (dumData) => dumData.policy_type_name === featuresType
            )?.intimate_claim_visibility !== 0 && (
              <div
                className={
                  activeViewType == 1
                    ? "claim-corner-policy-tab active-claim-corner-policy-tab"
                    : "claim-corner-policy-tab"
                }
                onClick={() => handleFeatureTab(1)}
              >
                {/* <span className="claim-corner-nav-icon-box">
                  <img src={IntimateclaimsIcon} />
                </span> */}
                Intimate my Claim
              </div>
            )}
            <div
              className={
                activeViewType == 0
                  ? "claim-corner-policy-tab active-claim-corner-policy-tab"
                  : "claim-corner-policy-tab"
              }
              onClick={() => handleFeatureTab(0)}
            >
              {/* <span className="claim-corner-nav-icon-box">
                <img src={claimStausIcon} />
              </span> */}
              Claim Status
            </div>
          </>
        ) : ["GPA", "GTL"].includes(featuresType) ? (
          <>
           <div
              className={
                activeViewType == 0
                  ? "claim-corner-policy-tab active-claim-corner-policy-tab"
                  : "claim-corner-policy-tab"
              }
              onClick={() => handleFeatureTab(0)}
            >
              <span className="claim-corner-nav-icon-box">
                <img src={claimStausIcon} />
              </span>
              Claim Status
            </div>
            {tabapiData?.find(
              (dumData) => dumData.policy_type_name === featuresType
            )?.intimate_claim_visibility == 1 && (
              <div
                className={
                  activeViewType == 1
                    ? "claim-corner-policy-tab active-claim-corner-policy-tab"
                    : "claim-corner-policy-tab"
                }
                onClick={() => handleFeatureTab(1)}
              >
                <span className="claim-corner-nav-icon-box">
                  <img src={IntimateclaimsIcon} />
                </span>
                Intimate my Claim
              </div>
            )}
           
          </>
        ) : (
          <div
            className={
              activeViewType == 0
                ? "claim-corner-policy-tab active-claim-corner-policy-tab"
                : "claim-corner-policy-tab"
            }
            onClick={() => handleFeatureTab(0)}
          >
            <span className="claim-corner-nav-icon-box">
              <img src={claimStausIcon} />
            </span>
            Claim Status
          </div>
        )}
      </div>
    </div>
  );
};

export default ClaimFeaturesTabs;
